"use client";

import { isPublicRoute, useInactivityTimer } from "@/lib/helpers";
import { useSessionStore } from "@/lib/stores/useSessionStore";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export default function InactivityWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const router = useRouter();
  const pathname = usePathname();
  const setSessionExpired = useSessionStore((state) => state.setSessionExpired);
  const sessionExpired = useSessionStore((state) => state.sessionExpired);
  const [isChecking, setIsChecking] = useState(true);

  // Public routes (e.g. /legal) have no session — never expire or redirect them.
  const isPublic = isPublicRoute(pathname);

  const handleTimeout = () => {
    if (isPublic) return;
    setSessionExpired(true);
    const locale = pathname.split("/")[1];
    router.push(`/${locale}/expired`);
  };

  useInactivityTimer(handleTimeout);

  useEffect(() => {
    if (sessionExpired && !pathname.includes("/expired") && !isPublic) {
      const locale = pathname.split("/")[1];
      router.replace(`/${locale}/expired`);
    } else {
      setIsChecking(false);
    }
  }, [sessionExpired, pathname, router, isPublic]);

  if (isChecking) {
    return null;
  }

  return <>{children}</>;
}
